<template>
  <ChatModal
    :name="$options.name"
    :title="$t('socialSpace.searchTitle')"
    width="550"
    @before-open="beforeOpen"
  >
    <div>
      <SearchInput
        v-model="query"
        @clear="query = ''"
      />
      <tabs
        :tabs="tabs"
        :currentTab="currentTab"
        :class="$style.tabs"
        ref="tabs"
        @onClick="tab => currentTab = tab"
      />
      <div :class="$style.list">
        <div v-if="!displayList.length" :class="$style.placeholder">
          <div v-if="!query">{{ $t('startTypingForSearch') }}</div>
          <div v-else>{{ $t('searchNoResults') }}</div>
        </div>
        <router-link
          v-for="profile in displayList" :key="profile.nickname"
          :to="{ name: 'social', params: { profileNickname: profile.nickname } }"
          :class="$style.item"
          @click.native="$modal.hide($options.name)"
        >
          <div :class="$style.avatarWrap">
            <img
              :src="profile.picture" :alt="`${profile.nickname} profile picture`"
              :class="$style.image"
            >
          </div>
          <div :class="$style.info">
            <div :class="$style.name">{{ profile.firstName }} {{ profile.lastName }}</div>
            <div>/{{ profile.nickname }}</div>
          </div>
        </router-link>
      </div>
    </div>
  </ChatModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChatModal from './ChatModal'
import Tabs from 'vue-tabs-with-active-line'
import SearchInput from '@/components/SearchInput'
import Fuse from 'fuse.js'

export default {
  name: 'social-search',
  components: {
    ChatModal,
    Tabs,
    SearchInput
  },
  data () {
    return {
      currentTab: 'accounts',
      query: ''
    }
  },
  computed: {
    ...mapGetters({
      getAllProfiles: 'entities/socialProfiles/all'
    }),
    tabs () {
      return [
        {
          title: this.$t('socialSpace.accounts'),
          value: 'accounts'
        },
        {
          title: this.$t('socialSpace.tags'),
          value: 'tags',
          disabled: true
        },
        {
          title: this.$t('socialSpace.places'),
          value: 'places'
        }
      ]
    },
    allProfiles () {
      return this.getAllProfiles()
    },
    foundProfiles () {
      const fuse = new Fuse(this.allProfiles, {
        keys: ['nickname', 'firstName', 'lastName']
      })
      return fuse.search(this.query)
    },
    foundProfilesByPlace () {
      const fuse = new Fuse(this.allProfiles, {
        keys: ['textLocation']
      })
      return fuse.search(this.query)
    },
    displayList () {
      if (!this.query || !this.allProfiles) return []
      return this.currentTab === 'places' ? this.foundProfilesByPlace : this.foundProfiles
    }
  },
  methods: {
    beforeOpen () {
      this.currentTab = 'accounts'
      this.query = ''
      this.fetchProfiles()
    },
    ...mapActions({
      fetchProfiles: 'entities/socialProfiles/fetchAll'
    })
  }
}
</script>

<style module lang="scss">
.list {
  height: 400px;
  overflow-y: scroll;
  margin-top: 8px;
}
.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.item {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  cursor: pointer;
  border-bottom: 1px solid $border-color;
}
.avatarWrap {
  width: 44px;
  height: 44px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  overflow: hidden;
  flex-shrink: 0;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.info {
  margin-left: 16px;
  color: $text-darkest;
}
.name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
  width: 100%;
}
</style>
